import React, { Fragment, useEffect, useState } from "react";
import { ReactComponent as EyeIcon } from "assets/images/common/svgs/eyeIconTable.svg";
import { useSelector } from "react-redux";
import { NotificationFiltersDTO } from "utils/helpers/models/common/user-filters.dto";
import DataNotFound from "components/particles/table/data-not-found";
import Pagination from "components/particles/table/pagination";
import useNotifications from "./useHooks";
import NotificationModal from "./component";


const NotificationListing: React.FC = () => {
  const [data, setData] = useState<any[]>([]);
  const { getNotifications } = useNotifications();
  const [filters, setFilters] = useState<NotificationFiltersDTO>(
    () => new NotificationFiltersDTO()
  );
  const [totalElements, setTotalElements] = useState<number>(0);

  const [selectedNotification, setSelectedNotification] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const buildUpdatedFilters = (
    updates: Partial<NotificationFiltersDTO> = {},
    resetPage: boolean = false
  ) => {
    const updatedFilters = { ...filters, ...updates };
    if (resetPage) {
      updatedFilters.page = 1;
    }
    return updatedFilters;
  };

  const handleViewClick = (item: any) => {
    setSelectedNotification(item);
    setIsModalOpen(true);
  };

  const onPageChange = (pageInfo: { selected: number; limit: number }) => {
    const { selected: page, limit } = pageInfo;
    const updatedFilters: NotificationFiltersDTO = buildUpdatedFilters(
      { size: limit, limit, page: page + 1 },
      false
    );
    setFilters(updatedFilters);
    getAllNotifications(updatedFilters);
  };

  const getAllNotifications = (filters: NotificationFiltersDTO) => {
    const filtersToSend: any = {};
    for (let key in filters) {
      if (filters[key]) filtersToSend[key] = filters[key];
    }
    const queryParams = {
      ...filtersToSend,
      page: filters.page - 1,
    };
    getNotifications(setData, queryParams, setFilters, setTotalElements);
  };

  useEffect(() => {
    getAllNotifications(filters);
  }, []);


  const { isLoading } = useSelector((state: any) => state.sharedReducer);
  const columns: string[] = ["Title", "Description", "Date", "To", "Action"];

  return (
    <div className="">
      <h1 className="tex-2xl sm:text-[32px] text-primaryText font-bold mb-6">
        Notifications
      </h1>
      <div className="flex justify-end items-center gap-5 "></div>

      <div className="w-full flex flex-col gap-4">
        <div className="bg-white rounded-t-lg  border border-mediumGrayBorder overflow-x-auto">
          <table className="min-w-full divide-y divide-mediumGrayBorder">
            {/* Table Header */}
            <thead className="bg-white">
              <tr className="text-left">
                {columns.map((column, index) => {
                  return (
                    <th
                      className="px-4 py-4 text-sm font-bold text-left text-primaryText whitespace-nowrap"
                      key={index}
                    >
                      {column}
                    </th>
                  );
                })}
              </tr>
            </thead>

            {/* Table Body */}
            <tbody className="bg-white divide-y divide-mediumGrayBorder">
              {data?.map((item: any, index: number) => (
                <tr key={index + 1} className="hover:bg-gray-50 ">
                  <td className="px-4 py-4 text-sm  text-primaryText font-semibold whitespace-nowrap">
                    {item?.title}
                  </td>
                  <td className="px-4 py-4 text-sm text-primaryText font-semibold whitespace-nowrap">
                    {item?.description?.split(' ').slice(0, 10).join(' ')}
                    {item?.description?.split(' ').length > 10 ? '...' : ''}
                  </td>
                  <td className="px-4 py-4 text-sm  text-primaryText font-semibold whitespace-nowrap">
                    {item.createdAt
                      ? new Date(item.createdAt).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })
                      : ""}
                  </td>
                  <td className="px-4 py-4 text-sm  text-primaryText font-semibold whitespace-nowrap">
                    {item?.sender?.firstName} {item?.sender?.lastName}
                  </td>

                  <td className="px-4 py-4 text-left whitespace-nowrap w-[124px]">
                    <div className="flex justify-start gap-2 ">

                      <button onClick={() => handleViewClick(item)}>
                        <EyeIcon />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <Fragment>
        <DataNotFound show={!isLoading && !data.length} />
        {totalElements > 0 && (
          <Pagination
            count={totalElements}
            page={filters.page}
            limit={filters.limit}
            onPageChange={onPageChange}
          />
        )}
      </Fragment>

      {

        isModalOpen && (
          <NotificationModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            content={selectedNotification}
          />
        )
      }
    </div>
  );
};

export default NotificationListing;
